import { CustomAccountSelect } from 'components/custom-ui/CustomSelect';
import DateSelect from 'components/custom-ui/DateSelect';
import { FormContainer, FormRowView } from 'components/shared';
import { UIAmountInput, UITextInput } from 'components/ui';
import React from 'react';
import { useStateManager } from "bcms-react";
import "./styles.css";
import Classes, { Account } from "model";

/**
 * @function MobileMultiWireTable
 * @return {React.Component}
 * @exported true
 * @description The mobile view of the multi wire table
 */

export default function MobileMultiWireTable(props) {
  const { onChange } = useStateManager();
  const wire = props.wire ?? {};
  const payeeType = wire.payee.payeeType.charAt(0).toUpperCase() + wire.payee.payeeType.slice(1);

  return(
    <FormContainer className="mobile-multi-wire-table">
      <FormRowView>
        <b>{ wire.payee.nickname }</b>
      </FormRowView>
      <FormRowView>
        <p>Payee Name: <b>{ wire.payee.name }</b></p>
      </FormRowView>
      <FormRowView>
        <p>Type: <b>{ payeeType }</b></p>
      </FormRowView>
      <FormRowView text="Wire Date:">
        <DateSelect value={ wire.wireDate } onChange={ onChange("wireDate", wire) } />
      </FormRowView>
      <FormRowView text="Account:">
        <CustomAccountSelect value={ wire.fundingAccount } accounts={ Account.initAllAsset() } onChange={ onChange("fundingAccount", wire) } />
      </FormRowView>
      <FormRowView text="Amount:">
        <UIAmountInput value={ wire.amount.amount === "" ? undefined : wire.amount.format({style:"decimal"}) } onBlur={ onChange("amount", wire) } />
      </FormRowView>
      <FormRowView>
        <p><span className="last">Last: <b>N/A</b></span><span className="scheduled">Scheduled: <b>N/A</b></span></p>
      </FormRowView>
      <FormRowView text="Memo:">
        <UITextInput value={ wire.memo } onBlur={ onChange("memo", wire) } />
      </FormRowView>
    </FormContainer>
  );
}